import React, { useState } from "react";

import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { Box } from "@mui/material";

import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import { ProducaoForrageira } from "./producaoForrageira";
import { IntensividadeProdutiva } from "./intensividade_produtiva";
import { IAlimentoComposto, IGrupos_Homo_Eficiencia_Alimentar, IIntensidadeProdutiva, INecessidade_EA, IProducao_forrageira } from "../../../Interfaces/eficiencia_alimentar/plano_de_alimentacao";
import EficienciaAlimentarViewTecnico from "../../../Styles/layout/eficienciaAlimentarView";
import { CabecalhoGrupoHomoEficiencia } from "./cabecalho_grupo_homo";
import { NecessidadesAlimentares } from "./necessidade";
import { AlimentoComposto } from "./alimento_composto";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
        },

        toolbars: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(2, 3),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },
        contents: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
    })
);


export default function EFPlanoAlimentar() {
    const classes = useStyles();

    const [obj_producaoForrageira, set_obj_ProducaoForrageira] = useState<IProducao_forrageira>();

    const [obj_intensidade, set_obj_intensidade] = useState<IIntensidadeProdutiva>();

    const [obj_grupos_homo, set_obj_grupos_homo] = useState<IGrupos_Homo_Eficiencia_Alimentar>();

    const [rows_necessidades, set_rows_necessidades] = useState<INecessidade_EA[]>([])

    const [rows_alimento, set_rows_alimento] = useState<IAlimentoComposto[]>([])





    return (
        <div className={classes.root}>
            <EficienciaAlimentarViewTecnico
                title="Plano Alimentar"
            />
            <main className={classes.contents}>
                <div className={classes.toolbars} />

                <Box width="80%" margin="auto">
                    <BeneficiarioNomeIdAlinhadoDireita />
                </Box>

                <ProducaoForrageira
                    tabela={obj_producaoForrageira}
                    set_obj_intensidade={set_obj_intensidade}
                    setTabela={set_obj_ProducaoForrageira}
                />

                <IntensividadeProdutiva
                    tabela={obj_intensidade}
                    setTabela={set_obj_intensidade}
                    tabela_producao={obj_producaoForrageira}
                    total_cn_from_tabela_necessidades_arg={5}
                />

                <CabecalhoGrupoHomoEficiencia
                    obj_Cabecalho={obj_grupos_homo}
                    set_obj_Cabecalho={set_obj_grupos_homo}
                    set_obj_intensidade={set_obj_intensidade}
                    set_rows_necessidades={set_rows_necessidades}
                    set_rows_alimento={set_rows_alimento}
                />

                <NecessidadesAlimentares
                    rows={rows_necessidades}
                    setRows={set_rows_necessidades}
                />

                <AlimentoComposto
                    rows={rows_alimento}
                    setRows={set_rows_alimento} />

            </main>
        </div>
    );
}